var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invadobay-preview__card"},[_c('vb-card',{attrs:{"card":{
      image: _vm.default_image,
      image_style: {
        cursor: 'pointer',
        'background-color': 'white',
        ...(!_vm.elem.cover_media
          ? {
              'background-size': '45%',
            }
          : {}),
      },
      title: _vm.elem.title,
      title_style: { cursor: 'pointer' },
      title_popover: _vm.elem.title, 
      text: `<div class='text-muted' style='height:3lh'>${
        _vm.elem.description || ''
      }</div>`,
      text_popover: _vm.elem.description, 
      text_clamped: true,
      variant: 'vertical',
    }},on:{"click_image":(e) => _vm.$refs[_vm.invadobay_path].navigate(e || {}),"click_title":(e) => _vm.$refs[_vm.invadobay_path].navigate(e || {})},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('custom-link',{ref:_vm.invadobay_path,attrs:{"route_path":_vm.invadobay_path,"as_default":_vm.get_config('guiSettings.openDetailNewTab', false)},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('span',{staticClass:"text-info link"},[_vm._v(" Vedi tutte le proposte ")])]},proxy:true}])})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }